import React from 'react';
import {

    DateInput,
    Create,
    SelectInput,
    TextInput,
    required,
    choices,
    TabbedForm,
    Toolbar,
    SaveButton,
    ListButton,
    CardActions,
    ImageInput,
    ImageField,
    FormTab,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import jwt_decode from 'jwt-decode'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';


const genderValues = [
    {
        id: 'Male',
        name: 'Male'
    },
    {
        id: 'Female',
        name: 'Female'
    },
    {
        id: 'Other',
        name: 'Other'
    }
]

const diferralCodes = [
    {
        id: 'ID',
        name: 'Indefinitely Deferred'
    },
    {
        id: 'N/A',
        name: 'Not applicable'
    },
    {
        id: 'PR',
        name: 'Permanently rejected'
    },
    {
        id : 'TD',
        name: 'Temporarly Deferred'
    }
]

export const styles = {

  hidden: {
    display: 'none'
  }
};

const validateGender = choices(['Male', 'Female','Other'], 'Must be Male, Female or Other');

const DonorCreateToolbar = props => (
    <Toolbar {...props} >
      { ((((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 1) &&
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
      /> }
    </Toolbar>
);

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const DonorCreateActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} />
    </CardActions>
);

const Verify = ({ classes, ...props }) => (
<Create {...props} actions={<DonorCreateActions />} >
      <TabbedForm  toolbar={<DonorCreateToolbar />}>
        <FormTab label="Identity">
            <Table style={{ margin: 'auto',  fontSize:'12px', cellspacing:"3", borderWidth:"1", width:"100%"}} >
            <TableBody  >
                <TableRow >
                        <TableCell  ><TextInput source="ssn"  label="SSN"  validate={required()}/></TableCell>
                        <TableCell  ><TextInput source="first_name"   label="First Name" validate={required()}/></TableCell  >
                        <TableCell  ><TextInput source="last_name"   label="Last Name" validate={required()} /></TableCell  >
                </TableRow>
                <TableRow>
                    <TableCell  ><TextInput source="middle_name"   label="Middle Name" /></TableCell>
                    <TableCell  ><DateInput source="dob"    label="DOB" validate={required()} locales="en-us"/></TableCell>
                    <TableCell  ><SelectInput source="gender" lable="Gender"  choices={genderValues} validate={required()} /></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell  ><TextInput source="apt"   label="Apt/Suit#" /></TableCell>
                    <TableCell  ><TextInput source="street"   label="Street" validate={required()} /></TableCell>
                    <TableCell  ><TextInput source="city"   label="City" validate={required()}/></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell  ><TextInput source="zip"    label="Zip" /></TableCell>
                    <TableCell  ><SelectInput source="state"  label="State" /></TableCell>
                    <TableCell  ><TextInput source="don_ph"  label="Phone"/></TableCell>
                </TableRow>
                </TableBody>
            </Table>
        </FormTab>
        <FormTab label="Deferral">
            <SelectInput source="deferral_code"    label="Deferral code" choices={diferralCodes}  validate={required()} defaultValue={'N/A'}/>
            <DateInput source="deferral_date"    label="Deferral date" locales="en-us"  locales="en-us"/>
            <DateInput source="deferral_exp_date"    label="Deferral Exp date" locales="en-us"  locales="en-us"/>
            <DateInput source="created_date"    label="Created date" locales="en-us"  className={classes.hidden} defaultValue={new Date()}/>
            <TextInput source="created_by"    label="Created by"  className={classes.hidden} defaultValue= {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).user_name : '' )}  />
            <TextInput source="deferral_comments" label=""  rowsMax={4} multiline fullWidth  label="Deferral comments"/>
            <DateInput source="last_mod_date"    label="Last modifyed date" locales="en-us"  className={classes.hidden} defaultValue={new Date()}/>
            <TextInput source="last_mod_by"    label="Created by"  className={classes.hidden} defaultValue= {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).user_name : '' )}  />
        </FormTab>
        <FormTab label="Allergies">
            <TextInput source="allergies" label=""  rowsMax={4} multiline fullWidth  label="Allergies"/>
        </FormTab>
        <FormTab label="Photo / ID">
            <lable>Donor photo (Add/Edit)</lable>
            <ImageInput source="pictures" label="" accept="image/*" minSize={0} maxSize={2000000}>
                <ImageField source="src" title="Donor" />
            </ImageInput>
            <lable>Donor photo (View)</lable>
            <ImageField source="photo_url" label="" />
            <br />
            <lable>Social Security Number proof (Add/Edit)</lable>
            <ImageInput source="photo_id_1" label="" accept="image/*" minSize={0} maxSize={2000000}>
                <ImageField source="src" title="One" />
            </ImageInput>
            <lable>Social Security Number proof  (View)</lable>
            <ImageField source="photo_id_1_url" label="" />
            <br />
            <lable>Address proof (Add/Edit)</lable>
            <ImageInput source="photo_id_2" label="" accept="image/*" minSize={0} maxSize={2000000}>
                <ImageField source="src" title="Two" />
            </ImageInput>
            <lable>Address proof (View)</lable>
            <ImageField source="photo_id_2_url" label="" />
        </FormTab>
      </TabbedForm>
    </Create>
);

export default withStyles(styles)(Verify);

